import Translation from 'components/Translation'
import { useBookingPageContext } from 'context/bookingContext/BookingPageContainer'
import { CALENDAR_DISPLAY_OPTIONS } from 'components/Modals/CustomBookingPage/BookingPageOptions'
import { classNames } from 'utils/dom-helpers'

export function CalendarContainerButton() {
    const { calendarDisplay, setCalendarDisplay } = useBookingPageContext()

    return (
        <div className="flex flex-wrap items-center lg:w-1/4 k-justify-content-end appointment-view-filter">
            {/* Label */}
            {/* <Translation
                render_as="span"
                className="mr-2"
                content_key="booking_page.show_calendar"
            /> */}
            {/* <Translation content_key="booking_page.datestrip_view" /> */}

            <h1 className="text-lg font-semibold mr-4">View as: </h1>
            {/* Dropdown */}
            <select
                className="border rounded-lg px-4 py-2 lg:w-1/2 font-bold bg-white text-[#2C2E31]"
                value={calendarDisplay}
                onChange={(e) => setCalendarDisplay(e.target.value)}
            >
                {/* {console.log(
                    CALENDAR_DISPLAY_OPTIONS,
                    'CALENDAR_DISPLAY_OPTIONS'
                )} */}
                    {/* {console.log(<Translation content_key="booking_page.datestrip_view" />, "CALENDAR_DISPLAY_OPTIONS")} */}
                {CALENDAR_DISPLAY_OPTIONS.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                        className={classNames(
                            option.value === calendarDisplay
                                ? 'bg-[#3350DF] text-white'
                                : 'bg-white text-[#2C2E31]'
                        )}
                    >{option.title}
                        {/* <Translation content_key={option.title} /> */}
                        {/* <Translation content_key="booking_page.calendar_view" /> */}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default CalendarContainerButton
